import type { BillingEntitlements } from '../../lib/billing/api'

function meterPercent(used: number, cap: number): number {
  if (cap <= 0) return 0
  return Math.min(100, Math.round((used / cap) * 100))
}

function meterLabel(entitlements: BillingEntitlements): string {
  if (entitlements.tier === 'pro') {
    return `${entitlements.used} of ${entitlements.cap} optimizations used this billing period`
  }
  return `${entitlements.used} of ${entitlements.cap} optimizations used (lifetime)`
}

export interface SubscriptionUsageMeterProps {
  entitlements: BillingEntitlements
  testId?: string
}

export function SubscriptionUsageMeter({
  entitlements,
  testId = 'subscription-meter',
}: SubscriptionUsageMeterProps) {
  const exhausted = entitlements.remaining <= 0
  const percent = meterPercent(entitlements.used, entitlements.cap)

  return (
    <div className="mb-3">
      <div
        role="progressbar"
        aria-valuenow={entitlements.used}
        aria-valuemin={0}
        aria-valuemax={entitlements.cap}
        aria-label={`${entitlements.used} of ${entitlements.cap} optimizations used`}
        className="h-2 rounded-full bg-surface-muted overflow-hidden mb-1.5"
        data-testid={testId}
      >
        <div
          className={`h-full rounded-full transition-all duration-fast ${
            exhausted ? 'bg-danger' : 'bg-brand-primary'
          }`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-small text-text-secondary m-0">{meterLabel(entitlements)}</p>
    </div>
  )
}
